// TermsAndConditions.js

import React from 'react';

const TermsAndConditions = () => {
return (
    <div  style={{ textAlign: 'center', margin: '20px' }}>
  <h1 style={{ color: 'rgb(251, 205, 50)', display: 'inline' }}>
    Terms and Conditions
  </h1>
  <p style={{ color: 'white' }}>
    Disclaimer: The Essential 8 maturity report provided herewith by Cyber Ethos is based solely on the responses provided by the end user. While our utmost diligence and expertise have been exercised in the creation of this report, it is important to acknowledge that the accuracy and completeness of the findings are contingent upon the accuracy and completeness of the user's responses. As such, Cyber Ethos cannot be held liable for any actions, decisions, or outcomes that may arise from the reliance on this report until a comprehensive and further assessment, conducted by our team, has been undertaken to align the findings with the specific needs and nuances of your organisation's cybersecurity requirements. We strongly recommend engaging us in a more detailed evaluation by our experts to ensure an accurate and tailored cybersecurity maturity assessment.
  </p>
</div>
);
};

export default TermsAndConditions;
